import React from 'react';
import PropTypes from 'prop-types';

const CloseIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 10 10">
        <path d="M6.188 5L9.75 8.563A.84.84 0 018.563 9.75L5 6.188 1.437 9.75A.84.84 0 01.25 8.563L3.812 5 .25 1.437A.84.84 0 011.437.25L5 3.812 8.563.25A.84.84 0 019.75 1.437z" fill={fill} fillRule="evenodd" />
    </svg>
);

CloseIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

CloseIcon.defaultProps = {
    width: '10',
    height: '10',
    fill: '#333'
};

export default CloseIcon;
